import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PurchaseKindQuery, PurchaseKindQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseKindQuery)
@Wrapper(PurchaseKindQueryHandlerBase)
export class PurchaseKindQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
